<template>
  <div class="app-footer embeddable-footer p-2 text-nowrap" >
    <a href="https://www.icij.org" target="_blank" class="text-white embeddable-footer__brand">
      <brand :size="40" no-border class="mr-2" color="white" />
    </a>
    <div class="embeddable-footer__lead small text-truncate">
      <!-- @slot Main slot to redefine lead text display -->
      <slot>

        <a href="https://www.icij.org/investigations/pandora-papers/secrecy-brokers" target="_blank" class="text-white">
          <span>Pandora Papers - Secrecy Brokers</span>
        </a>
      </slot>
    </div>

  </div>
</template>

<script>

import utils from '@/mixins/utils'
import IframeResizer from '@/utils/iframe-resizer'

export default {
  name: 'AppFooter',
  mixins: [utils],
  props: {
    title: {
      default: ``,
      type: String
    }
  },
  data () {
    return {
      enableFooter: true,
      sharingOptionsValues: Object,
      showShareOptions: false
    }
  },
  mounted () {
    IframeResizer.create();
  }
}
</script>
